module.exports = "$((()=>{$('[data-toggle=\"tooltip\"]').tooltip()}));"